import AddIcon from "@mui/icons-material/Add";
import { Button, CircularProgress } from "@mui/material";
import moment from "moment";
import { useState, useRef } from "react";
import { Accordion, Row, Container, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { normalizeErrorMessages } from "api/common/utils/rtkq.utils";
import {
  useGetNistByProductIdQuery,
  useIsNcrtTeamMemberQuery,
} from "api/memberPortal/certReview/certReview.api";
import NISTForm from "components/NIST/NISTForm";
import { useAuth } from "hooks/useAuth";

export default function CertificateReviewAccordion({ product_id }) {
  const { permissions, currentUser } = useAuth();
  const navigate = useNavigate();
  const tableRef = useRef();
  const [showForm, setShowForm] = useState(false);

  const {
    data: nistReview,
    isLoading,
    error,
    refetch: refetchNistReview,
  } = useGetNistByProductIdQuery(product_id);

  const navigateToPage = () => {
    if (!nistReview?.crid) {
      return;
    }
    navigate(`nist/${nistReview.crid}`);
  };

  const handleShowForm = () => {
    setShowForm(true);
  };

  const handleHideForm = () => {
    setShowForm(false);
  };

  const { data: isNCRTTeamMember } = useIsNcrtTeamMemberQuery(currentUser.id);

  const refetch = () => {
    if (tableRef.current) {
      tableRef.current.onQueryChange();
    }
    refetchNistReview();
  };

  const errorMessage = normalizeErrorMessages(error);

  return (
    <Accordion flush className="border border-dark mb-3" defaultActiveKey="1">
      <Accordion.Item eventKey="1">
        <Accordion.Header className="bg-secondary">
          <h6 className="sidebar-title">NIST Certificate Review</h6>
        </Accordion.Header>
        <Accordion.Body className="bg-light p-1">
          {isLoading ? (
            <div className="d-flex justify-content-center my-2">
              <CircularProgress />
            </div>
          ) : errorMessage === "Nist not found." || !nistReview?.crid ? (
            <Container>
              <Row className="d-flex justify-content-center mb-2">
                <NISTForm
                  show={showForm}
                  onHide={handleHideForm}
                  refetch={refetch}
                  currentProductId={product_id}
                />
                {permissions.role_type === "NIAP" || isNCRTTeamMember ? (
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    color="success"
                    onClick={handleShowForm}
                    sx={{ maxWidth: "calc(100% - 4em)", marginTop: 0.75 }}
                  >
                    New Certificate Review
                  </Button>
                ) : (
                  <p className="mb-0 text-center">----------</p>
                )}
              </Row>
            </Container>
          ) : (
            <Container data-cy="product_detail_nist_review_accordion">
              <Row>
                <Col>
                  <Row>
                    <p className="text-secondary">Submitted:</p>
                  </Row>
                  <Row className="border-bottom">
                    <p data-cy="product_detail_nist_review_accordion_rcvd">
                      <span className="me-2">
                        {nistReview?.rcvd &&
                          moment.utc(nistReview.rcvd).format("YYYY.MM.DD")}
                      </span>
                      by
                      <br></br>
                      {`${nistReview?.creator?.first_name}  ${nistReview?.creator?.last_name}`}
                    </p>
                  </Row>
                  <Row>
                    <p className="text-secondary">
                      Status:{" "}
                      <span className="text-black">
                        {nistReview?.stid?.status}
                      </span>
                    </p>
                  </Row>
                  <Row>
                    <p className="text-secondary">
                      Completed:{" "}
                      <span className="text-black">
                        {[
                          "Rejected - Revision Required",
                          "Approved",
                          "Rejected, revisions needed",
                          "No Certificate Review Needed",
                        ]?.includes(nistReview?.stid?.status)
                          ? nistReview?.enddate &&
                            moment.utc(nistReview?.enddate).format("YYYY.MM.DD")
                          : "TBD"}
                      </span>
                    </p>
                  </Row>
                  <Row>
                    <Button
                      variant="text"
                      className="text-bright-blue"
                      onClick={navigateToPage}
                    >
                      View Details
                    </Button>
                  </Row>
                </Col>
              </Row>
            </Container>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}
